import { CreateRequest, EditRequest, ManageRequest } from '../pages';
import { Requests } from '../Requests';
import { RouteObject } from 'react-router-dom';
import { Authorize } from '@/components';
import { ROLES } from '@/components/security/AppRoles';
import { ErrorPage } from '@/pages/Layout/pages';

export const RequestsRoute: RouteObject[] = [
  {
    path: 'requests',
    element: <Requests />,
  },
  {
    path: 'requests/create',
    element: (
      <Authorize
        permission={ROLES.INVENTORY.leader}
        fallback={<ErrorPage code={403} />}
      >
        <CreateRequest />
      </Authorize>
    ),
  },
  {
    path: 'requests/:id/manage',
    element: (
      <Authorize
        permission={ROLES.INVENTORY.admin}
        fallback={<ErrorPage code={403} />}
      >
        <ManageRequest />
      </Authorize>
    ),
  },
  {
    path: 'requests/:id/edit',
    element: <EditRequest />,
  },
];

export default RequestsRoute;
